<template>
    <div class="table-responsive mt-3 import-error-table">
        <table class="table" style="text-align: center">
            <thead>
            <tr style="border: 1px solid #ebedf3">
                <th class="header-table w-60px" scope="col">STT</th>
                <th class="header-table min-w-80px" scope="col">Id</th>
                <th class="header-table min-w-100px" scope="col">Mã HĐ</th>
                <th class="header-table min-w-120px" scope="col">Trạng thái</th>
                <th class="header-table min-w-100px" scope="col">Mã trạng thái</th>
                <th class="header-table min-w-220px" scope="col">Kết quả kiểm tra</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="item of responseError"
                :key="item.rowIndex"
                style="border: 1px solid #ebedf3; border-top: 0"
            >
                <td>{{ item.rowIndex }}</td>
                <td style="text-align: start">{{ item.id }}</td>
                <td style="text-align: start">{{ item.contractCode }}</td>
                <td style="text-align: start">{{ item.processingStatus }}</td>
                <td style="text-align: start">{{ item.processingStatusCode }}</td>
                <td style="text-align: start">
                    <div
                        v-if="item.errors && item.errors.length"
                        class="import-error-table__errors"
                    >
                        <span>Lỗi:</span>
                        <span
                            v-for="(error, index) in item.errors"
                            :key="index + error"
                            style="word-break: break-word"
                        >
                            - {{ error }}
                        </span>
                    </div>
                    <span v-else class="import-error-table__success">Đạt</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "TableErrorImportDepositRefund",
    props: {
        responseError: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style scoped>
.import-error-table {
    overflow: auto;
    padding-bottom: 30px;
    max-height: 70vh;
}

.header-table {
    background: #f8f8f8;
    text-align: start;
    word-break: break-word;
}

.import-error-table__errors {
    text-align: start;
    display: flex;
    flex-direction: column;
    color: #d52323;
    font-weight: 500;
}

.import-error-table__success {
    color: #0c9200;
    font-weight: 500;
}
</style>
